export default "__VITE_ASSET__6f591174__"